<template>
  <textarea class="textarea-content" ref="WTextarea"
            :style="{ height: textareaHeight, lineHeight: this.textareaLineHeight }"
            v-bind:value="textareaValue"
            v-on:input="changeValue($event)"
            :placeholder="placeholder"
            :maxlength="fontMaxSize" :autofocus="autofocus"/>
</template>

<script>
  import calcTextareaHeight from "../../views/hackathon/caleTextarea"
  export default {
    name: 'w-auto-textarea',
    props: {
      placeholder: {
        type: String,
        default: ''
      },
      textareaValue: {
        type: String,
        default: ''
      },
      minRow: {
        type: Number,
        default: 1
      },
      maxRow: {
        type: Number,
        default: 4
      },
      fontMaxSize: {
        type: [ Number, String ],
        default: 3
      },
      autofocus: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'textareaValue',
      event: 'input'
    },
    data() {
      return {
        textareaHeight: '21px',
        textareaLineHeight: ''
      }
    },
    mounted() {
      this.textareaLineHeight = calcTextareaHeight(this.$refs.WTextarea, 1, 1).height
      this.calcHeight()
    },
    computed: {},
    watch: {
      textareaValue () {
        this.calcHeight()
      }
    },
    components: {},
    methods: {
      changeValue($event) {
        this.$emit('input', $event.target.value)
      },
      calcHeight() {
        this.textareaHeight = calcTextareaHeight(this.$refs.WTextarea, this.minRow, this.maxRow).height
      },
      onFocus() {
        this.$refs.WTextarea.focus()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/assets/scss/global/variable";
  @import "src/assets/scss/global/mixin";
</style>